export const UPDATE_APP_VERSION_REQUEST = 'UPDATE_APP_VERSION_REQUEST';
